import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider, ProtectedRoute } from './auth';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <ProtectedRoute
        loginPageProps={{
          appName: 'Backlog Generator Accelerator',
          companyName: 'GFT Colombia',
        }}
      >
        <App />
      </ProtectedRoute>
    </AuthProvider>
  </React.StrictMode>
);
